<template>
	<div class="map-controls-inline" :class="{ 'map-controls--open': showAmenities }">
		<button
			@click="showAmenities = !showAmenities"
			:class="
				showAmenities
					? 'map-controls__amenitybtn'
					: 'map-controls__amenitybtn map-controls__amenitybtn--collapsed'
			"
		>
			{{ labels.filter_by_amenities }}
			<svg class="icon icon-chevron">
				<use xlink:href="#icon-chevron"></use>
			</svg>
		</button>

		<div class="map-filters" v-show="showAmenities">
			<!-- <div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="ccs" value="ccs" />
				<label for="ccs" class="map-filter-inline">
					<svg class="icon icon-ccs">
						<use xlink:href="#icon-ccs"></use>
					</svg>
					{{ labels.ccs_charging }}
				</label>
			</div> -->
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="mcs" value="mcs" />
				<label for="mcs" class="map-filter-inline">
					<svg class="icon icon-mcs">
						<use xlink:href="#icon-mcs"></use>
					</svg>
					{{ labels.mcs_charging }}
				</label>
			</div>
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="secure" value="secure" />
				<label for="secure" class="map-filter-inline">
					<svg class="icon icon-secure-parking">
						<use xlink:href="#icon-secure-parking"></use>
					</svg>
					{{ labels.secure_parking }}
				</label>
			</div>
			<!-- <div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="drive_through" value="drive_through" />
				<label for="drive_through" class="map-filter-inline">
					<svg class="icon icon-drive-through-parking">
						<use xlink:href="#icon-drive-through-parking"></use>
					</svg>
					{{ labels.drive_through_parking }}
				</label>
			</div> -->
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="restaurant" value="restaurant" />
				<label for="restaurant" class="map-filter-inline">
					<svg class="icon icon-restaurant">
						<use xlink:href="#icon-restaurant"></use>
					</svg>
					{{ labels.restaurant }}
				</label>
			</div>
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="vending_machine" value="vending_machine" />
				<label for="vending_machine" class="map-filter-inline">
					<svg class="icon icon-vending-machine">
						<use xlink:href="#icon-vending-machine"></use>
					</svg>
					{{ labels.vending_machine }}
				</label>
			</div>
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="toilet" value="toilet" />
				<label for="toilet" class="map-filter-inline">
					<svg class="icon icon-toilet">
						<use xlink:href="#icon-toilet"></use>
					</svg>
					{{ labels.toilet }}
				</label>
			</div>
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="shower" value="shower" />
				<label for="shower" class="map-filter-inline">
					<svg class="icon icon-shower">
						<use xlink:href="#icon-shower"></use>
					</svg>
					{{ labels.shower }}
				</label>
			</div>
			<div class="map-filter-inline">
				<input type="checkbox" v-model="amenities" id="lounge" value="lounge" />
				<label for="lounge" class="map-filter-inline">
					<svg class="icon icon-lounge">
						<use xlink:href="#icon-lounge"></use>
					</svg>
					{{ labels.lounge }}
				</label>
			</div>
		</div>

		<div
			:class="selectedMarker ? 'map-controls__wrapper map-controls__wrapper--slideOut' : 'map-controls__wrapper'"
		>
			<slot></slot>

			<MapboxGeocoder
				access-token="pk.eyJ1IjoiYmVudG9kYXkiLCJhIjoiY2xlNzh4Y3lhMDM1bzN1bWdrYTFmMWN5bCJ9.fvgJSulDCj8AeuQ-pb8CYg"
				:marker="false"
				:zoom="7"
				:placeholder="labels.find"
				:flyTo="{ zoom: 8 }"
			/>
		</div>
	</div>
</template>

<script>
import { MapboxGeocoder } from '@studiometa/vue-mapbox-gl';
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css';
export default {
	components: {
		MapboxGeocoder,
	},
	props: ['selectedMarker', 'labels'],
	data() {
		return {
			amenities: [],
			search: '',
			showAmenities: window.innerWidth >= 768 ? true : false,
		};
	},
	watch: {
		amenities(amenities) {
			this.$emit('filter', amenities);
		},
		search(term) {
			this.$emit('search', term);
		},
	},
	methods: {
		clearTerm() {
			this.search = '';
			this.$emit('deselectMarker');
		},
		geocoder(instance) {
			console.log(instance);
		},
	},
};
</script>
